var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentCross = function SvgDocumentCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 82,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__a)",
    d: "M80 45.2c0-8.625-6.899-15.69-15.468-15.976V16.39c0-.336-.133-.66-.373-.898L49.412.762a1.27 1.27 0 0 0-.896-.371H7.866c-.702 0-1.27.568-1.27 1.269v6.905H1.27C.568 8.565 0 9.133 0 9.834v70.505c0 .702.568 1.27 1.27 1.27h54.292c.7 0 1.269-.568 1.269-1.27v-5.318h6.434c.7 0 1.269-.568 1.269-1.27v-12.57C73.1 60.894 80 53.824 80 45.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.387 8.957h-20.26c-.702 0-1.27.568-1.27 1.27V30.46c0 .7.568 1.269 1.27 1.269h20.26c.7 0 1.269-.568 1.269-1.27V10.227c0-.701-.57-1.269-1.27-1.269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__b)",
    d: "M28.768 23.22h-.992a3.729 3.729 0 0 0-1.521-7.132 3.726 3.726 0 0 0-1.521 7.132h-.992c-2.584.022-4.69 2.14-4.69 4.725v3.784h14.406v-3.784c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__c)",
    d: "M55.003 24.786H42.258a1.269 1.269 0 1 1 0-2.538h12.745a1.269 1.269 0 1 1 0 2.538"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__d)",
    d: "M55.003 31.73H42.258a1.269 1.269 0 1 1 0-2.539h12.745a1.269 1.269 0 1 1 0 2.539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__e)",
    d: "M40.744 66.454H16.127a1.269 1.269 0 1 1 0-2.538h24.617a1.269 1.269 0 1 1 0 2.538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__f)",
    d: "M7.865 75.02a1.27 1.27 0 0 1-1.269-1.269V8.564H1.27c-.702 0-1.27.568-1.27 1.27v70.505c0 .701.568 1.27 1.27 1.27h54.292c.7 0 1.269-.569 1.269-1.27V75.02z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__g)",
    d: "M49.412.763a1.26 1.26 0 0 0-.896-.368V15.28c0 .614.498 1.112 1.112 1.112H64.53c0-.33-.127-.655-.37-.898z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__h)",
    d: "M28.768 23.22h-.992a3.7 3.7 0 0 1-1.521.324 3.7 3.7 0 0 1-1.521-.323h-.992c-2.584.022-4.69 2.14-4.69 4.725v3.784h14.406v-3.784c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__i)",
    d: "M63.995 61.19C72.81 61.19 80 54.004 80 45.2s-7.189-15.985-16.005-15.985c-8.817 0-16.006 7.181-16.006 15.985s7.19 15.99 16.006 15.99"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__j)",
    d: "M16.127 45.618h31.868q-.005-.21-.005-.419c0-.718.05-1.426.141-2.119H16.127a1.269 1.269 0 1 0 0 2.538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__k)",
    d: "M16.127 38.675h33.26c.402-.892.884-1.742 1.436-2.538H16.127a1.269 1.269 0 1 0 0 2.538"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__l)",
    d: "M53.18 56.969H16.128a1.269 1.269 0 1 0 0 2.538h38.16c.532 0 .987-.327 1.176-.792a16 16 0 0 1-2.282-1.746"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentCross_svg__m)",
    d: "M16.127 52.565h33.67a16 16 0 0 1-1.058-2.538H16.127a1.269 1.269 0 1 0 0 2.538"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.981 41.404a2.263 2.263 0 0 1 0-3.207 2.275 2.275 0 0 1 3.208 0l3.805 3.8 3.806-3.8a2.275 2.275 0 0 1 3.207 0c.889.886.889 2.32 0 3.207l-3.805 3.798 3.805 3.8c.889.887.889 2.321 0 3.208a2.275 2.275 0 0 1-3.207 0l-3.806-3.8-3.805 3.8a2.275 2.275 0 0 1-3.208 0 2.263 2.263 0 0 1 0-3.208l3.803-3.8z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-67.55036 73.55574 -68.15407 -62.5897 73.914 5.678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFCBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EDF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.16473 14.1653 -13.02148 -11.18246 32.362 17.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.9054 2.29857 -.73802 -4.14364 55.11 22.413)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.9054 2.29857 -.73802 -4.14364 55.11 29.357)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.275 18.371 33.04)scale(23.0447 4.25377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-47.98682 66.15254 -58.47742 -42.41932 52.507 13.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(133.026 31.344 14.474)scale(19.8188 18.3863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.647 12.733 16.581)scale(14.4002 12.1074)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.09593 2.29855 -.34742 -4.24667 45.6 43.245)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(175.672 23.358 19.06)scale(30.4558 4.2629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.165 25.23 29.444)scale(34.3638 4.26552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentCross_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.5024 2.29858 -.33107 -4.2493 47.139 50.193)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentCross_svg__i",
    x1: 63.995,
    x2: 63.995,
    y1: 26.746,
    y2: 72.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgDocumentCross;